import { render, staticRenderFns } from "./FormAdicionarUsuario.vue?vue&type=template&id=70d5650f&scoped=true"
import script from "./FormAdicionarUsuario.vue?vue&type=script&lang=js"
export * from "./FormAdicionarUsuario.vue?vue&type=script&lang=js"
import style0 from "./FormAdicionarUsuario.vue?vue&type=style&index=0&id=70d5650f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5650f",
  null
  
)

export default component.exports